module.exports = __webpack_public_path__ + "img/xlh@2x.1b045f64.png";